import { useAlterarDominanteDialog } from "./use-alterar-dominante-dialog";
import { AlterarDominanteDialogView } from "./view-alterar-dominante-dialog";
import type { AlterarDominanteDialogProps } from "./types-alterar-dominante-dialog";

export function AlterarDominanteDialog(props: AlterarDominanteDialogProps) {
  const vm = useAlterarDominanteDialog(props);

  return <AlterarDominanteDialogView {...props} {...vm} />;
}

export type * from "./types-alterar-dominante-dialog";
